var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{staticClass:"openMultipositionPopupWrapper",attrs:{"title":_vm.$t('Multipozicija')}},[_c('Button',{attrs:{"data-test":"multiposition-button","icon":"table"},on:{"click":_vm.onOpenMultipositionPopup}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }